import merge from "lodash/merge";
import api from "./api";
import config from "../config";

export default {
  fetchAll(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets`,
          qs: { include_archived: true },
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.event_buckets);
        }
      );
    });
  },

  fetchOne(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${eventBucket}`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  edit(apiKey, eventBucket, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `event_buckets/${eventBucket}`,
          json: values,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            err._eventBucket = eventBucket;
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  uploadFile(apiKey, eventBucket, key, file) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `event_buckets/${eventBucket}/upload_file`,
          fileField: key,
          file: file,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  delete(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: `event_buckets/${eventBucket}`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  duplicate(apiKey, { id, fields }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `event_buckets/${id}/duplicate`,
          json: { fields },
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  create(apiKey, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `event_buckets`,
          json: values,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchConfigSchema(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: "_frontend/schema",
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  testSubdomain(apiKey, eventBucket, subdomain) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `event_buckets/${eventBucket}/test_subdomain`,
          json: { subdomain },
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/EventBucketUtil.js